import { render, staticRenderFns } from "./StudentNoteItem.vue?vue&type=template&id=3af99464&scoped=true&"
import script from "./StudentNoteItem.vue?vue&type=script&lang=js&"
export * from "./StudentNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentNoteItem.vue?vue&type=style&index=0&id=3af99464&lang=scss&scoped=true&"
import style1 from "./StudentNoteItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af99464",
  null
  
)

export default component.exports